import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "bettertomorrow-630db.firebaseapp.com",
  projectId: "bettertomorrow-630db",
  storageBucket: "bettertomorrow-630db.appspot.com",
  messagingSenderId: "174690154604",
  appId: process.env.REACT_APP_API_ID
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage();
export const db = getFirestore();
export const googleProvider = new GoogleAuthProvider();

// FCM messaging — only available in supported browsers
export const messagingPromise = isSupported().then((yes) =>
  yes ? getMessaging(app) : null
);
